import React from "react";
import Card from "./Card";
import Pagination from "./Pagination";

function FetchPlaces({ places = [], cardsCategory = "places", cardsSize, resultsOnPage, pageNumber, setPageNumber, search, backContext }) {
  const isEvents = cardsCategory === "events";
  const pageItems = places.slice(pageNumber * resultsOnPage, pageNumber * resultsOnPage + resultsOnPage);
  const topPagination = places.length > 0 ? (
    <Pagination
      resultsOnPage={resultsOnPage}
      pageNumber={pageNumber}
      setPageNumber={setPageNumber}
      collection={places}
      search={search}
      scrollToTopOnChange={false}
    />
  ) : null;

  const bottomPagination = places.length > 0 ? (
    <Pagination
      resultsOnPage={resultsOnPage}
      pageNumber={pageNumber}
      setPageNumber={setPageNumber}
      collection={places}
      search={search}
      scrollToTopOnChange={true}
    />
  ) : null;

  return (
    <div>
      {topPagination}
      {pageItems.map((place) => (
        <Card
          key={place._id}
          cardsCategory={cardsCategory}
          place={isEvents ? undefined : place}
          event={isEvents ? place : undefined}
          cardsSize={cardsSize}
          backContext={backContext}
        />
      ))}
      {bottomPagination}
    </div>
  );
}

export default FetchPlaces;
